import { render, staticRenderFns } from "./addHolidaysModal.vue?vue&type=template&id=7affad26&"
import script from "./addHolidaysModal.vue?vue&type=script&lang=js&"
export * from "./addHolidaysModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports